import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { Button } from "../../../common/Button";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { CustomPhoneInput } from "../../../common/PhoneInput";

export const Details = ({
  onContinue,
  defaultName,
  defaultPhone,
  isLoading,
}: {
  onContinue: () => void;
  defaultName: string;
  defaultPhone?: string;
  isLoading?: boolean;
}) => {
  const { handleSubmit, register, control, getValues } = useForm();
  const [fullName, setFullName] = useState(defaultName);
  const [kudaId, setKudaId] = useState("");
  const vals = getValues();
  const [phoneVal, setPhoneVal] = useState(defaultPhone);
  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onContinue)}>
        <div className={styles.form}>
          <div className={styles.accNumInput}>
            <Input
              register={register}
              value={fullName}
              onChange={(e: any) => setFullName(e.target.value)}
              inputId="fullname"
              type="text"
              label="Full name"
              placeholder="Full name"
              required
            />
          </div>
          <div className={styles.dualInput}>
            <Input
              register={register}
              inputId="kudaid"
              type="number"
              label="Kuda pay ID"
              placeholder=""
              required
              value={kudaId}
              onChange={(e: any) => setKudaId(e.target.value)}
            />

            <CustomPhoneInput
              register={register}
              inputId="phone"
              type="text"
              label="Phone number"
              placeholder="Phone number"
              control={control}
              required
              value={phoneVal}
              setVal={setPhoneVal}
            />
          </div>
        </div>
        <ButtonFooter showNote>
          <Button
            type="submit"
            text="Continue"
            buttonStyle="primary"
            isButtonLoading={isLoading}
            disabled={
              !vals?.kudaid || !vals?.phone?.length || !vals?.fullname?.length
            }
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
